import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { mapState } from 'vuex';
export default {
  props: {
    controlConfig: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    associationInfo: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      propsTree: {
        children: 'children',
        label: 'name',
        value: 'id',
        multiple: false
      }
    };
  },
  computed: {
    ...mapState({
      countriesData: state => state.quiretionnaire.countriesData,
      provinceFirstLevel: state => state.quiretionnaire.provinceFirstLevel,
      provinceData: state => state.quiretionnaire.provinceData,
      provinceArea: state => state.quiretionnaire.provinceArea,
      logisticsData: state => state.quiretionnaire.logisticsData,
      bankData: state => state.quiretionnaire.bankData
    }),
    optionsValue() {
      let type = this.controlConfig.type.type;
      if (type === 'provinceArea') {
        return this.provinceArea;
      } else if (type === 'province') {
        return this.provinceData;
      } else if (type === 'country') {
        return this.countriesData;
      } else if (type === 'provinceFirstLevel') {
        return this.provinceFirstLevel;
      } else if (type === 'bank') {
        return this.bankData;
      } else if (type === 'logistics') {
        return this.logisticsData;
      } else if (type === 'custom') {
        // let loop = data => {
        //   return data.map(item => {
        //     if (item.children) {
        //       item.children = loop(item.children);
        //     }
        //     return item;
        //   });
        // };
        return JSON.parse(JSON.stringify(this.controlConfig.dataList));
      }
    }
  },
  created() {
    // let type = this.controlConfig.type.type;
    // if (type === 'custom') {
    //   let loop = data => {
    //     return data.map(item => {
    //       if (item.children) {
    //         item.children = loop(item.children);
    //       }
    //       return item;
    //     });
    //   };
    //   this.optionsValue = loop(this.controlConfig.dataList);
    // }
    this.propsTree.multiple = this.controlConfig.isMultipleChoice;
  },
  mounted() {
    this.cascaderChange();
  },
  methods: {
    handleDropDownData(value, item) {
      const generaterText = mapObj => {
        let textValue = [];
        value.forEach(valueArr => {
          let text = '';
          valueArr.forEach((value, index) => {
            if (index === valueArr.length - 1) {
              text = text + mapObj[value];
            } else {
              text = text + mapObj[value] + '/';
            }
          });
          textValue.push(text);
        });
        return textValue;
      };
      let textData = [];
      if (item.type.type === 'provinceArea') {
        textData = generaterText(this.provinceAreaObj);
      } else if (item.type.type === 'province') {
        textData = generaterText(this.provinceDataObj);
      } else if (item.type.type === 'provinceFirstLevel') {
        textData = generaterText(this.provinceFirstLevelObj);
      } else if (item.type.type === 'country') {
        textData = generaterText(this.provinceDataObj);
      } else if (item.type.type === 'bank') {
        textData = generaterText(this.bankDataObj);
      } else if (item.type.type === 'logistics') {
        textData = generaterText(this.logisticsDataObj);
      } else if (item.type.type === 'custom') {
        const loop = (data, obj) => {
          data.forEach(item => {
            obj[item.code] = item.name;
            if (item.children) {
              loop(item.children, obj);
            }
          });
          return obj;
        };
        let mapObj = loop(item.dataList);
        textData = generaterText(mapObj);
      }
      return {
        textValue: textData,
        codeValue: value
      };
    },
    cascaderChange() {
      //如果有关联控件，判断是否显示
      let currentMark = this.controlConfig.mark;
      this.$emit('valueChange', currentMark);
      if (this.associationInfo[currentMark]) {
        let associationInfo = this.associationInfo[currentMark];
        associationInfo.forEach(associationItem => {
          let show = false;
          let value = associationItem.value;
          let selectValue = this.formData[currentMark];
          if (Array.isArray(selectValue)) {
            let valueArr = [];
            selectValue.forEach(item => {
              if (Array.isArray(item)) {
                valueArr.push(item[0]);
              } else {
                valueArr.push(item);
              }
            });
            let interset = valueArr.filter(item => value.includes(item));
            if (interset.length > 0) {
              show = true;
            }
          }
          this.$emit('showControl', show, associationItem.targetKey);
        });
      }
    }
  }
};